import { Validator } from '@vista-digital/validator';
import { fieldDisplayTextValidatorSchema } from '../../types/field-display-text';
export const passwordFieldDisplayTextValidator = Validator.object({
    label: fieldDisplayTextValidatorSchema.label,
    placeholder: fieldDisplayTextValidatorSchema.placeholder
});
export const defaultPasswordFieldDisplayText = {
    label: 'Password'
};
//# sourceMappingURL=display-text.js.map